// --- START OF FILE Text.js ---
// components/user/Text.js
import React, { useState, useEffect } from "react";
import { useNode } from "@craftjs/core";
import ContentEditable from 'react-contenteditable';
import { FormControl, FormLabel, Slider, Select, MenuItem } from "@material-ui/core";

export const Text = ({
                         text,
                         fontSize,
                         textAlign,
                         fontWeight,
                         color,
                         margin
                     }) => {
    const { connectors: { connect, drag }, selected, actions: { setProp } } = useNode(
        (node) => ({
            selected: node.events.selected
        })
    );

    const [editable, setEditable] = useState(false);

    useEffect(() => {
        if (!selected) {
            setEditable(false);
        }
    }, [selected]);

    return (
        <div
            ref={ref => connect(drag(ref))}
            onClick={() => selected && setEditable(true)}
            style={{ position: 'relative', margin: `${margin}px` }}
        >
            <ContentEditable
                html={text}
                disabled={!editable}
                onChange={e => setProp(props => props.text = e.target.value.replace(/<\/?[^>]+(>|$)/g, ""))}
                tagName="p"
                style={{
                    fontSize: `${fontSize}px`,
                    textAlign,
                    fontWeight,
                    color,
                    margin: 0,
                    padding: '3px',
                    border: selected ? '1px dashed blue' : 'none'
                }}
            />
            {selected && (
                <div style={{
                    padding: '10px',
                    marginTop: '10px',
                    background: '#f8f9fa',
                    borderRadius: '4px'
                }}>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>Font Size</FormLabel>
                        <Slider
                            value={fontSize}
                            step={1}
                            min={12}
                            max={80}
                            onChange={(_, value) => setProp(props => props.fontSize = value)}
                        />
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>Alignment</FormLabel>
                        <Select
                            value={textAlign}
                            onChange={e => setProp(props => props.textAlign = e.target.value)}
                        >
                            <MenuItem value="left">Left</MenuItem>
                            <MenuItem value="center">Center</MenuItem>
                            <MenuItem value="right">Right</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>Font Weight</FormLabel>
                        <Select
                            value={fontWeight}
                            onChange={e => setProp(props => props.fontWeight = e.target.value)}
                        >
                            <MenuItem value="normal">Normal</MenuItem>
                            <MenuItem value="bold">Bold</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>Color</FormLabel>
                        <input
                            type="color"
                            value={color}
                            onChange={e => setProp(props => props.color = e.target.value)}
                            style={{ width: '100%', height: '30px' }}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <FormLabel>Margin</FormLabel>
                        <Slider
                            value={margin}
                            step={1}
                            min={0}
                            max={40}
                            onChange={(_, value) => setProp(props => props.margin = value)}
                        />
                    </FormControl>
                </div>
            )}
        </div>
    );
};

Text.craft = {
    props: {
        text: 'Click to edit text',
        fontSize: 16,
        textAlign: 'left',
        fontWeight: 'normal',
        color: '#000000',
        margin: 0
    }
}